import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import HekateImageViewer from './HekateImageViewer';
window.mountHekateImageViewer = function mountHekateImageViewer(containerId, props) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('HekateImageViewer: container not found:', containerId);
        return { type: 'image', unmount: () => { }, get api() { return null; } };
    }
    // Add wrapper class for fullscreen and layout
    container.classList.add('hekate-image-viewer-wrapper');
    const mountPoint = document.createElement('div');
    container.appendChild(mountPoint);
    const apiRef = createRef();
    const root = createRoot(mountPoint);
    root.render(React.createElement(HekateImageViewer, { ...props, containerElement: container, ref: apiRef }));
    return {
        type: 'image',
        unmount: () => {
            root.unmount();
            mountPoint.remove();
            container.classList.remove('hekate-image-viewer-wrapper');
        },
        get api() {
            return apiRef.current;
        },
    };
};
